package uz.ferro.erp.locale

import uz.ferro.erp.model.DictItem

object LocaleDict {
    val appName = DictItem(
        textDefault = "Ferro CRM"
    )
    val login = DictItem(
        textDefault = "Login"
    )
    val enterToSystem = DictItem(
        textDefault = "Enter to system"
    )

    val password = DictItem(
        textDefault = "Password"
    )

    val signIn = DictItem(
        textDefault = "Sign In"
    )
}